// extracted by mini-css-extract-plugin
module.exports = {"kensaOrder_Detail":"PaymentReturn_kensaOrder_Detail__22dUL","kensaOrder_Footer":"PaymentReturn_kensaOrder_Footer__275GO"};